export namespace EquipmentSelect {
    export enum ViewStatus {
        search,
        preview,
        creationForm,
        fullView,
    }
}
